module.exports = __webpack_public_path__ + "static/img/蒙版组 18@2x.a199c8e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/蒙版组 18@2x.png
// module id = FCoF
// module chunks = 1